import React from "react";
import "../../css/Finance/SettlementGuidelines.css";

const SettlementGuidelines = () => {
    return (
        <details className="settlement-guidelines" open>
            <summary className="settlement-guidelines-summary">
                <div>
                    <div className="settlement-guidelines-title">Najważniejsze zasady rozliczania</div>
                    <div className="settlement-guidelines-subtitle">Krótka ściąga przy ręcznym rozliczaniu wyjazdu</div>
                </div>
                <i className="fa-solid fa-chevron-down settlement-guidelines-chevron" />
            </summary>

            <div className="settlement-guidelines-content">
                <div className="settlement-guidelines-reminder">
                    <i className="fa-solid fa-circle-info" />
                    <span>Przed rozpoczęciem rozliczenia upewnij się, że masz od osoby koordynatorskiej informację o znalezionych zastępstwach, kosztach poniesionych prywatnie oraz kosztach odzyskanych dla konkretnych osób.</span>
                </div>

                <div className="settlement-guidelines-grid">
                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Pełne zwroty i zastępstwa</div>
                        <div>Jeżeli za anulowaną osobę lub rezerwację znaleziono zastępstwo, anulowanej osobie co do zasady zwracamy jej wpłatę. Jeżeli przed anulowaniem zostało już wykupione NNW/KR, poniesiony koszt ubezpieczenia nie podlega zwrotowi.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Koszt administracyjny</div>
                        <div>Naliczamy go za osoby obecne, nieobecne oraz anulowane, za które nie znaleziono zastępstwa. Nie naliczamy go osobie z całkowitym pokryciem kosztów udziału ani osobie indywidualnie zwolnionej z kosztu administracyjnego.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">TFG / TFP</div>
                        <div>Naliczamy je za osoby obecne i nieobecne. Dla osoby anulowanej składka jest odzyskiwana i odzyskaną kwotę należy jej zwrócić. W przypadku osoby z całkowitym pokryciem kosztów udziału przypadający na nią koszt TFG/TFP rozkłada się na pozostałe osoby uczestniczące.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">NNW / KR</div>
                        <div>Jeżeli osoba anuluje udział przed wykupieniem ubezpieczenia, pobraną na ten cel kwotę należy jej zwrócić. Jeżeli NNW/KR zostało już wykupione, pozostaje faktycznie poniesionym kosztem wyjazdu i nie podlega zwrotowi.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Odzyskane koszty indywidualne</div>
                        <div>Jeżeli udało się odzyskać koszt poniesiony wcześniej na rzecz konkretnej osoby, odzyskaną kwotę należy uwzględnić w jej indywidualnym zwrocie. Dotyczy to również osoby obecnej, która nie skorzystała z opłaconego elementu wyjazdu, jeżeli koszt udało się odzyskać.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Fundusz Solidarnościowy</div>
                        <div>Dofinansowanie nie jest własną wpłatą osoby. Dla osoby obecnej zwrot trafia najpierw do niej, ale nie może przekroczyć faktycznie poniesionego przez nią kosztu. Dla osoby nieobecnej lub anulowanej zwrot w pierwszej kolejności wraca do Funduszu do wysokości przyznanego dofinansowania, a dopiero nadwyżka trafia do osoby.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Podział pozostałej puli</div>
                        <div>Po uwzględnieniu kosztów i należnych zwrotów indywidualnych pozostałą pulę dzielimy pomiędzy osoby obecne, nieobecne oraz anulowane, za które nie znaleziono zastępstwa.</div>
                    </div>

                    <div className="settlement-guideline-item">
                        <div className="settlement-guideline-heading">Bilans końcowy</div>
                        <div>Po uwzględnieniu wszystkich kosztów i zwrotów rozliczenie powinno bilansować się do 0 zł lub wartości bardzo bliskiej zeru. Niespodziewaną stratę albo nadwyżkę warto wyjaśnić przed wykonaniem końcowych zwrotów.</div>
                    </div>
                </div>
            </div>
        </details>
    );
};

export default SettlementGuidelines;
